import { defaultTo } from "rambda";

import { DirectionType, SwipeObserver } from "./SwipeObserver";

/**
 * Action for working with SwipeObserver in svelte components
 * @param node
 * @param options
 * @returns
 */
export function swipeable(
    node: HTMLElement,
    options: {
        tolerance: number;
        direction: DirectionType;
        enableMouseEvents?: boolean;
        onSwipe: () => void;
        onShift: (shift: number | null) => void;
    }
): {
    destroy: () => void;
} {
    const observer = new SwipeObserver({
        enableMouseEvent: defaultTo(true, options.enableMouseEvents),
        target: node,
        tolerance: options.tolerance,
        direction: options.direction,
    });
    const { shift$, swipe$ } = observer.start();
    const swipeSubscripton = swipe$.subscribe(() => {
        options.onSwipe();
    });
    const shiftSubscription = shift$.subscribe((v) => {
        if (v) {
            options.onShift(v);
            node.style.transform = `translateX(${v}px) translateZ(0)`;
        } else {
            options.onShift(null);
            node.style.transform = "";
        }
    });
    return {
        destroy() {
            swipeSubscripton.unsubscribe();
            shiftSubscription.unsubscribe();
        },
    };
}
